<template>
  <div>
    <v-overlay :value="loading" :absolute="true">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>

      <v-card-title :style="{ backgroundColor: $root.currentTheme.background }">
        {{$t('Reports.LoadsRefines')}}
        <!--<v-spacer/>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>-->
      </v-card-title>
      <!--<hr/>
      {{loads}}
      <hr/>-->

      <v-list v-if="$root.isMobile">
        <template v-for="item in items">
          <v-list-item :key="item.id" @click="onShowHistory(item.vrData)">
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <small>{{item.createdPST}}</small>
                <div>{{ $t('by') }}&nbsp;{{item.creatorFullName}}</div>
                <div><v-icon small>mdi-account</v-icon>&nbsp;{{item.userFullName}}</div>
                <template v-if="item.status === $store.getters.verifyStatuses.REFINE">
                  <v-chip color="error">
                    <v-icon left small>mdi-alert</v-icon>
                    {{$t('Loads.Refine')}}
                  </v-chip>
                </template>

                <template v-if="item.status === $store.getters.verifyStatuses.UNVERIFIED">
                  <v-chip>
                    <v-icon small left>mdi-check-circle</v-icon>
                    {{$t('Loads.UndoVerified')}}
                  </v-chip>
                </template>

                <template v-if="item.status === $store.getters.verifyStatuses.VERIFIED">
                  <v-chip color="success">
                    <v-icon small left>mdi-check-circle</v-icon>
                    {{$t('Loads.Verified')}}
                  </v-chip>
                </template>

                <template v-if="item.status === $store.getters.verifyStatuses.REFINED">
                  <v-chip color="warning">
                    <v-icon small left>mdi-alert</v-icon>
                    {{$t('Loads.Refined')}}
                  </v-chip>
                </template>

                <template v-if="item.status === $store.getters.verifyStatuses.EDITING_REQUEST">
                  <v-chip color="info">
                    <v-icon small left>mdi-information</v-icon>
                    {{$t('Loads.EditingUnlockRequested')}}
                  </v-chip>
                </template>

                <template v-if="item.status === $store.getters.verifyStatuses.EDITING_OVERRIDE">
                  <v-chip color="info">
                    <v-icon small left>mdi-information</v-icon>
                    {{$t('Loads.OverrideEditLock')}}
                  </v-chip>
                </template>

                <template v-if="item.status === $store.getters.verifyStatuses.WAITING_FURTHER_ACTIONS">
                  <v-chip color="warning">
                    <v-icon left small>mdi-alert</v-icon>
                    {{$t('Loads.MarkAsWaitingFurtherActions')}}
                  </v-chip>
                </template>
              </v-list-item-content>
              <v-list-item-action>
                <a href="#" @click.stop="$root.onShowLoadPreview(item.loadId)">#{{item.loadId}}</a>
                <template v-if="$root.isAccessRightAllowEdit($store.getters.loadsRights['isVerifyAllowed'])">
                  <LoadVerificationButtons
                    :item="{id: item.loadId, verifiedStatus: item.status, dispatcher: item.userId}" @fetch-data="fetchData"/>
                </template>
              </v-list-item-action>
            </template>
          </v-list-item>
          <v-expansion-panels flat dense v-if="item.note">
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('Notes') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                {{ item.note }}
              </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-list>

      <v-data-table
        v-else
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="100"
        :footer-props="footer_props"
        @click:row="onShowHistory($event.vrData)"
      >
        <template v-slot:item.loadId="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <p v-on="on"><a href="#" @click.stop="$root.onShowLoadPreview(item.loadId)">#{{item.loadId}}</a></p>
            </template>
            {{item.loadName}}
          </v-tooltip>
        </template>
        <template v-slot:item.created="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on"
                        style="cursor: pointer;"
                        class="mr-1"
                        :size="26"
                        :color="(item.creatorInitials && !item.creatorAvatar)?'#015aaa':null">
                <v-img :src="$root.getImageUrl('avatar', item.creatorAvatar)" v-if="item.creatorAvatar"></v-img>
                <span class="white--text" v-else-if="item.creatorInitials">{{item.creatorInitials}}</span>
                <v-icon large v-else>account_circle</v-icon>
              </v-avatar>
            </template>
            <span>{{item.creatorFullName}}</span>
          </v-tooltip>{{$t('At')}}&nbsp;{{item.createdPST}}
        </template>
        <template v-slot:item.user="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on"
                        style="cursor: pointer;"
                        class="mr-1"
                        :size="26"
                        :color="(item.userInitials && !item.userAvatar)?'#015aaa':null">
                <v-img :src="$root.getImageUrl('avatar', item.userAvatar)" v-if="item.userAvatar"></v-img>
                <span class="white--text" v-else-if="item.userInitials">{{item.userInitials}}</span>
                <v-icon large v-else>account_circle</v-icon>
              </v-avatar>
            </template>
            <span>{{item.userFullName}}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.count="{ item }">
          {{item.vrData.length}}
        </template>
        <template v-slot:item.notes="{ item }">
          <template v-if="item.note">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <p v-on="on" style="width:200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                  <span>{{item.note}}</span>
                </p>
              </template>
              <span>{{item.note}}</span>
            </v-tooltip>
          </template>
          <template v-if="item.refineNote">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <p v-on="on" style="width:200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                  <span>{{item.refineNote}}</span>
                </p>
              </template>
              <span>{{item.refineNote}}</span>
            </v-tooltip>
          </template>
          <template v-if="item.refinedNote">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <p v-on="on" style="width:200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                  <span>{{item.refinedNote}}</span>
                </p>
              </template>
              <span>{{item.refinedNote}}</span>
            </v-tooltip>
          </template>
          <template v-if="item.editingRequestNote">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <p v-on="on" style="width:200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                  <span>{{item.editingRequestNote}}</span>
                </p>
              </template>
              <span>{{item.editingRequestNote}}</span>
            </v-tooltip>
          </template>

        </template>
        <template v-slot:item.type="{ item }">
          <template v-if="item.status === $store.getters.verifyStatuses.REFINE">
            <v-chip color="error">
              <v-icon left small>mdi-alert</v-icon>
              {{$t('Loads.Refine')}}
            </v-chip>
            <!--<v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                <UserSnippet :user-data="{id: item.userCreated, avatarUPLOAD: item.avatarUPLOAD, firstName: item.firstName, lastName: item.lastName}" :avatar-only="true"/>
                {{$t('Loads.Refine')}}
                <v-btn icon small v-if="item.userCreated === $store.getters.currentUser.id || $store.getters.isUserRoleSuperAdmin" @click="onVerifyEdit(item)"><v-icon small>mdi-pen</v-icon></v-btn>
              </v-list-item-title>
              <v-list-item-content v-html="item.refineNote ? item.refineNote.replace(/(?:\r\n|\r|\n)/g, '<br/>') : ''"/>
            </v-list-item-content>-->
          </template>

          <template v-if="item.status === $store.getters.verifyStatuses.UNVERIFIED">
            <v-chip>
              <v-icon small left>mdi-check-circle</v-icon>
              {{$t('Loads.UndoVerified')}}
            </v-chip>
            <!--<v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                <UserSnippet :user-data="{id: item.userCreated, avatarUPLOAD: item.avatarUPLOAD, firstName: item.firstName, lastName: item.lastName}" :avatar-only="true"/>
                {{$t('Loads.UndoVerified')}}
                <v-btn icon small v-if="item.userCreated === $store.getters.currentUser.id || $store.getters.isUserRoleSuperAdmin" @click="onVerifyEdit(item)"><v-icon small>mdi-pen</v-icon></v-btn>
              </v-list-item-title>
              <v-list-item-content v-html="item.note ? item.note.replace(/(?:\r\n|\r|\n)/g, '<br/>') : ''"/>
            </v-list-item-content>-->
          </template>

          <template v-if="item.status === $store.getters.verifyStatuses.VERIFIED">
            <v-chip color="success">
              <v-icon small left>mdi-check-circle</v-icon>
              {{$t('Loads.Verified')}}
            </v-chip>
            <!--<v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                <UserSnippet :user-data="{id: item.userCreated, avatarUPLOAD: item.avatarUPLOAD, firstName: item.firstName, lastName: item.lastName}" :avatar-only="true"/>
                {{$t('Loads.Verified')}}
                <v-btn icon small v-if="item.userCreated === $store.getters.currentUser.id || $store.getters.isUserRoleSuperAdmin" @click="onVerifyEdit(item)"><v-icon small>mdi-pen</v-icon></v-btn>
              </v-list-item-title>
              <v-list-item-content v-html="item.note ? item.note.replace(/(?:\r\n|\r|\n)/g, '<br/>') : ''"/>
            </v-list-item-content>-->
          </template>

          <template v-if="item.status === $store.getters.verifyStatuses.REFINED">
            <v-chip color="warning">
              <v-icon small left>mdi-alert</v-icon>
              {{$t('Loads.Refined')}}
            </v-chip>
            <!--<v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                <UserSnippet :user-data="{id: item.userCreated, avatarUPLOAD: item.avatarUPLOAD, firstName: item.firstName, lastName: item.lastName}" :avatar-only="true"/>
                {{$t('Loads.Refined')}}
                <v-btn icon small v-if="item.userCreated === $store.getters.currentUser.id || $store.getters.isUserRoleSuperAdmin" @click="onVerifyEdit(item)"><v-icon small>mdi-pen</v-icon></v-btn>
              </v-list-item-title>
              <v-list-item-content v-html="item.refinedNote ? item.refinedNote.replace(/(?:\r\n|\r|\n)/g, '<br/>') : ''"/>
            </v-list-item-content>-->
          </template>

          <template v-if="item.status === $store.getters.verifyStatuses.EDITING_REQUEST">
            <v-chip color="info">
              <v-icon small left>mdi-information</v-icon>
              {{$t('Loads.EditingUnlockRequested')}}
            </v-chip>
            <!--<v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                <UserSnippet :user-data="{id: item.userCreated, avatarUPLOAD: item.avatarUPLOAD, firstName: item.firstName, lastName: item.lastName}" :avatar-only="true"/>
                {{$t('Loads.EditingUnlockRequested')}}
                <v-btn icon small v-if="item.userCreated === $store.getters.currentUser.id || $store.getters.isUserRoleSuperAdmin" @click="onVerifyEdit(item)"><v-icon small>mdi-pen</v-icon></v-btn>
              </v-list-item-title>
              <v-list-item-content v-html="item.vrEditingRequestNote ? item.vrEditingRequestNote.replace(/(?:\r\n|\r|\n)/g, '<br/>') : ''"/>
            </v-list-item-content>-->
          </template>

          <template v-if="item.status === $store.getters.verifyStatuses.EDITING_OVERRIDE">
            <v-chip color="info">
              <v-icon small left>mdi-information</v-icon>
              {{$t('Loads.OverrideEditLock')}}
            </v-chip>
            <!--<v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                <UserSnippet :user-data="{id: item.userCreated, avatarUPLOAD: item.avatarUPLOAD, firstName: item.firstName, lastName: item.lastName}" :avatar-only="true"/>
                {{$t('Loads.OverrideEditLock')}}
                <v-btn icon small v-if="item.userCreated === $store.getters.currentUser.id || $store.getters.isUserRoleSuperAdmin" @click="onVerifyEdit(item)"><v-icon small>mdi-pen</v-icon></v-btn>
              </v-list-item-title>
              <v-list-item-content v-html="item.note ? item.note.replace(/(?:\r\n|\r|\n)/g, '<br/>') : ''"/>
            </v-list-item-content>-->
          </template>

          <template v-if="item.status === $store.getters.verifyStatuses.WAITING_FURTHER_ACTIONS">
            <v-chip color="warning">
              <v-icon left small>mdi-alert</v-icon>
              {{$t('Loads.MarkAsWaitingFurtherActions')}}
            </v-chip>
            <!--<v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                <UserSnippet :user-data="{id: item.userCreated, avatarUPLOAD: item.avatarUPLOAD, firstName: item.firstName, lastName: item.lastName}" :avatar-only="true"/>
                {{$t('Loads.MarkAsWaitingFurtherActions')}}
                <v-btn icon small v-if="item.userCreated === $store.getters.currentUser.id || $store.getters.isUserRoleSuperAdmin" @click="onVerifyEdit(item)"><v-icon small>mdi-pen</v-icon></v-btn>
              </v-list-item-title>
              <v-list-item-content v-html="item.note ? item.note.replace(/(?:\r\n|\r|\n)/g, '<br/>') : ''"/>
            </v-list-item-content>-->
          </template>
        </template>
        <template v-slot:item.actions="{ item }">
          <template v-if="$root.isAccessRightAllowEdit($store.getters.loadsRights['isVerifyAllowed'])">
            <LoadVerificationButtons
              :item="{id: item.loadId, verifiedStatus: item.status, dispatcher: item.userId}"
              small @fetch-data="fetchData"/>
          </template>
        </template>
      </v-data-table>

    <LoadVerifyModal :modal="verifyEditingModal"
                     :item="selectedEditingRefine"
                     :key="'verifyEditingModal'+verifyEditingModal"
    />

    <v-dialog v-model="vrModal" max-width="720" scrollable>
      <v-card>
        <v-card-title>
          <h4>{{$t('History')}}</h4>
          <v-spacer></v-spacer>
          <v-btn icon class="mr-4" @click="vrModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <LoadRefinedHistory :vr-data="selectedVrData" :key="selectedVrDataKey" @on-verify-edit="onVerifyEdit" :readonly="true"/>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
import LoadVerificationButtons from '../../components/LoadVerificationButtons.vue';
import LoadRefinedHistory from '../../components/LoadRefineHistory.vue';
import LoadVerifyModal from '../../components/LoadVerifyModal';

export default {
  name: 'LoadsRefinesReport',
  props: ['from', 'to'],
  components: { LoadVerifyModal, LoadVerificationButtons, LoadRefinedHistory },
  mixins: [reportsMixin],
  data: function () {
    return {
      loading: false,
      items: [],
      search: '',
      selectedItems: [],
      verifyEditingModal: false,
      selectedEditingRefine: {},
      vrModal: false,
      selectedVrData: [],
      selectedVrDataKey: new Date().getTime(),
      headers: [
        { text: 'Load', value: 'loadId' },
        { text: 'User', value: 'user' },
        { text: 'Count', value: 'count' },
        { text: 'Last Status', value: 'type' },
        { text: 'Notes', value: 'notes' },
        { text: 'Created', value: 'created' },
        { text: '', value: 'actions', sortable: false }
      ],
      footer_props: {
        'items-per-page-options': [10, 25, 50, 100],
        'items-per-page-text': '',
        'disable-items-per-page': false
      }
    };
  },
  computed: {
  },
  mounted () {
    this.$root.setLastListPath(this.$route.path);
    this.$nextTick(() => {
      this.fetchData();
    });
  },
  methods: {
    onVerifyEdit (item) {
      this.selectedEditingRefine = item;
      this.verifyEditingModal = true;
    },
    onShowHistory (vrData) {
      this.selectedVrData = vrData;
      this.selectedVrDataKey = new Date().getTime();
      this.vrModal = true;
    },
    fetchData () {
      if (!this.from || !this.to) return;
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.getReportRefined(this.from, this.to).then((response) => {
          if (response.status === 'ok') {
            this.items = response.results;
          }
          resolve();
        });
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
